(function () {
  const DARK_MODE = 'dark';
  const LIGHT_MODE = 'light';
  const root = document.documentElement;
  const colorSchemeMedia =
    typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-color-scheme: dark)') : null;
  let hasManualOverride = false;

  function getSystemMode() {
    return colorSchemeMedia?.matches ? DARK_MODE : LIGHT_MODE;
  }

  function getActiveMode() {
    return root.dataset.themeMode === DARK_MODE ? DARK_MODE : LIGHT_MODE;
  }

  function updateThemeColor(mode) {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (!metaThemeColor) return;

    const variableName = mode === DARK_MODE ? '--theme-mode-dark-background-hex' : '--theme-mode-light-background-hex';
    const themeColor = getComputedStyle(root).getPropertyValue(variableName).trim();

    if (themeColor) {
      metaThemeColor.setAttribute('content', themeColor);
    }
  }

  function syncToggleState(mode) {
    document.querySelectorAll('theme-mode-toggle').forEach((toggle) => {
      if (typeof toggle.update === 'function') {
        toggle.update(mode);
      } else {
        toggle.dataset.themeMode = mode;
      }
    });
  }

  function setThemeMode(mode) {
    const nextMode = mode === DARK_MODE ? DARK_MODE : LIGHT_MODE;
    root.dataset.themeMode = nextMode;

    if (document.body) {
      document.body.dataset.themeMode = nextMode;
    }

    updateThemeColor(nextMode);
    syncToggleState(nextMode);
  }

  function applySystemMode() {
    hasManualOverride = false;
    setThemeMode(getSystemMode());
  }

  if (!customElements.get('theme-mode-toggle')) {
    customElements.define(
      'theme-mode-toggle',
      class ThemeModeToggle extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('.theme-mode-toggle__button');
          this.label = this.querySelector('.theme-mode-toggle__label');
          this.status = this.querySelector('[data-theme-mode-status]');
          this.darkLabel = this.button?.dataset.darkLabel || 'Dark';
          this.lightLabel = this.button?.dataset.lightLabel || 'Light';

          if (!this.button) return;

          this.onClick = this.onClick || this.handleClick.bind(this);
          this.button.addEventListener('click', this.onClick);
          this.update(getActiveMode());
        }

        disconnectedCallback() {
          this.button?.removeEventListener('click', this.onClick);
        }

        handleClick() {
          hasManualOverride = true;
          const nextMode = getActiveMode() === DARK_MODE ? LIGHT_MODE : DARK_MODE;
          setThemeMode(nextMode);
        }

        update(mode) {
          this.dataset.themeMode = mode;

          if (!this.button) return;

          const isDarkMode = mode === DARK_MODE;
          this.button.setAttribute('aria-pressed', isDarkMode ? 'true' : 'false');
          this.button.setAttribute('aria-label', isDarkMode ? 'Switch to light mode' : 'Switch to dark mode');

          if (this.label) {
            this.label.textContent = isDarkMode ? this.lightLabel : this.darkLabel;
          }

          if (this.status) {
            this.status.textContent = isDarkMode ? 'Dark mode on' : 'Dark mode off';
          }
        }
      }
    );
  }

  const initialMode = getSystemMode();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setThemeMode(initialMode), { once: true });
  } else {
    setThemeMode(initialMode);
  }

  if (colorSchemeMedia) {
    const onSchemeChange = () => {
      if (hasManualOverride) hasManualOverride = false;
      applySystemMode();
    };

    if (typeof colorSchemeMedia.addEventListener === 'function') {
      colorSchemeMedia.addEventListener('change', onSchemeChange);
    } else if (typeof colorSchemeMedia.addListener === 'function') {
      colorSchemeMedia.addListener(onSchemeChange);
    }
  }
})();
